import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  // eslint-disable-next-line no-unused-vars
  async getProps(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/props/getProps`,
      false,
    );
  },
});
